<template>
<div>
  
  <el-dialog
    title="导入异常数据"
    :visible.sync="dialogVisible"
    width="60%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <!-- 搜索区 -->
    <DirectRecordSearch
      :searchOptions="searchOptions"
      :searchData="searchParams"
      @onSearch="getList"
    />

     <c-table
        :listen-height="false"
        :refresh="tableInfo.refresh"
        :data.sync="tableInfo.data"
        :query="searchParams"
        :pager="true"
        :api="getExceptionList"
        :field-list="tableInfo.fieldList"
        :handle="tableInfo.handle"
        @handleClick="handleClick"
        @handleEvent="handleEvent"
      >
        <!-- 自定义列表内容 -->
        <template v-slot:col-type="scope">
          <span v-if="scope.row.type == 1">报名</span>
          <span v-else-if="scope.row.type == 2">合格证</span>
          <span v-else-if="scope.row.type == 3">学员</span>
        </template>

        <!-- 自定义列表内容 -->
        <template v-slot:col-state="scope">
          <p>{{ scope.row.status === 1 ? '已停用' : '已启用' }}</p>
        </template>
        
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-bf="scope">
          <el-button
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.item.label }}
          </el-button>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-delete="scope">
          <el-button
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.item.label }}
          </el-button>
        </template>
          
      </c-table>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>

  <HandleDateManage ref='dialogDateManage'></HandleDateManage>
</div>
</template>

<script>
import CTable from '@/components/PublicTableCopy';
import DirectRecordSearch from "@/components/Search/index";
import HandleDateManage from "./handle-date-manage";
import { getExceptionList,deleteExceptionList } from '@/api/api'
export default {
  components: {
    CTable,
    DirectRecordSearch,
    HandleDateManage
  },
  props: {
    importStatus:Number,
    editParams: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      getExceptionList,
      dialogVisible: false,
      tableInfo: {
        refresh: 1,
        initTable: false,
        data: [],
        fieldList: [
          { label: '排序号', value: 'id' },
          { label: '导入类型', value: 'type', type: 'slot'},
          { label: '所在行', value: 'row'},
          { label: '所在列', value: 'line'},
          { label: '文件名', value: 'fileName'},
          { label: '详情', value: 'details' },
          { label: '导入时间', value: 'lastUpdateDate'},
          { label: '操作人', value: 'insertName'},
        ],
        handle: {
          label: '操作',
          btList: [
            { label: '删除', type: 'text', event: 'delete', show: true, slot: true },
          ]
        }
      },
      // 搜索表单配置项
      searchOptions: [
        {
          type: "input",
          // label: "关键词",
          prop: "keyWord",
          width: "230px",
          placeholder: "请输入班级名称",
          // querySearchAsync: querySearchAsync,
        },
        {
          type: "select",
          // label: "培训班",
          prop: "type",
          width: "230px",
          placeholder: "",
          data:[{
            label:'导入报名',
            value:1
          },{
            label:'导入合格证',
            value:2
          },{
            label:'导入学员',
            value:3
          }]
          // querySearchAsync: querySearchAsync,
        },
      ],
      searchParams: {
        type:null,
        classId:null,
      },
    };
  },
  methods: {
    // table数据
    handleEvent(data) {
      this.tableInfo.data = data.records;
    },
    showDialog(componentName){
      this.$refs[componentName].setOpacity(true)
    },
    setOpacity(flg) {
      this.searchParams.type = this.importStatus
      this.searchParams.classId = this.editParams.id;
      this.dialogVisible = flg;
      this.$nextTick(()=>{
        this.getList()
      })
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 查询
    onSearch(data) {
        console.log(data)
    },
    edit(){

      this.showDialog('dialogDateManage');
    },
    // 通过随机数请求列表
    getList() {
      this.tableInfo.refresh = Math.random();
    },
    handleClick(event,row){
      console.log(row)
      if (event === 'edit') {
        this.edit();
        this.editChildParams = row;
      } else if (event === 'state') {
        updateFaceClassStatus({
          id: row.id,
          status:row.status === 1 ? 2 : 1
        }).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.$message.success(row.state === 1 ? '启用成功' : '停用成功');
            this.getList();
          } else {
            this.$message.error(message);
          }
        })
      } else {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteExceptionList({
            id: row.id
          }).then(res => {
            let { code, message } = res;
            if (code === 0) {
              this.$message.success('删除成功');
              this.getList();
            } else {
              this.$message.error(message);
            }
          })
        });
      }
    },
    // 切换选择
    changeTableSelection(val) {
      console.log(val);
    },
  },
  // watch: {
  //   editParams: {
  //     immediate: true,
  //     handler(newValue, oldValue) {
  //       this.searchParams.classId = newValue.classId
  //     },
  //   },
  // },
};
</script>

<style lang="scss">
.w50{
  width: 50%;
  display: inline-block;
}
.el-dialog__body{
  // max-height: 50vh;
  overflow-y: auto;
}
</style>
